import {
  createFrontendModule,
  PluginHeaderActionBlueprint,
  PluginWrapperBlueprint,
} from '@backstage/frontend-plugin-api';
import { LinkButton } from '@backstage/core-components';
import PublishIcon from '@material-ui/icons/Publish';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import {
  FormFieldBlueprint,
  TemplateCard,
} from '@backstage/plugin-scaffolder-react/alpha';
import { byxExecutionsSubPage } from '../executions';
import { useByxT } from '../shared/translations';
import { ByxTemplateCard } from './ByxTemplateCard';
import { scaffolderMessages, scaffolderReactMessages } from './translations';
import './wizard.css';

export const byxTemplateCard = SwappableComponentBlueprint.make({
  name: 'byx-template-card',
  params: define =>
    define({
      component: TemplateCard,
      loader: () => props => <ByxTemplateCard {...props} />,
    }),
});

// Wrapper de escopo: coloca .byx-scaffolder em volta das páginas do
// scaffolder para o wizard.css agir só nelas. display:contents não
// interfere no layout.
export const byxScaffolderWrapper = PluginWrapperBlueprint.make({
  name: 'byx-scaffolder-styles',
  params: define =>
    define({
      loader: () =>
        Promise.resolve({
          component: ({ children }) => (
            <div className="byx-scaffolder" style={{ display: 'contents' }}>
              {children}
            </div>
          ),
        }),
    }),
});

// Campos do template novo-servico: `ui:field: ByxDeploymentPicker` (rota →
// deployment declarado) e `ui:field: ByxReview` (revisão em blocos).
export const byxDeploymentPickerField = FormFieldBlueprint.make({
  name: 'byx-deployment-picker',
  params: {
    field: () =>
      import('./fields/DeploymentPicker').then(m => m.deploymentPickerField),
  },
});

export const byxReviewField = FormFieldBlueprint.make({
  name: 'byx-review',
  params: {
    field: () => import('./fields/ReviewField').then(m => m.reviewField),
  },
});

// Swappable components and translations only attach from the app plugin.
export const scaffolderModule = createFrontendModule({
  pluginId: 'app',
  extensions: [byxTemplateCard, scaffolderMessages, scaffolderReactMessages],
});

// "Registrar existente" in the Criar header, as the design's "Importar";
// the list page's own copy (in an otherwise empty row) is hidden in
// wizard.css.
function RegisterExistingButton() {
  const { t } = useByxT();
  return (
    <LinkButton
      to="/catalog-import"
      variant="outlined"
      startIcon={<PublishIcon />}
    >
      {t('home.pages.catalogImport')}
    </LinkButton>
  );
}

export const byxRegisterExistingAction = PluginHeaderActionBlueprint.make({
  name: 'byx-register-existing',
  params: {
    loader: () => Promise.resolve(<RegisterExistingButton />),
  },
});

// Criar › Execuções (Stories 5.1, 5.2; AC-24): `byxExecutionsSubPage` has
// the stock id `sub-page:scaffolder/tasks`, so this module replaces only
// the stock tasks sub-page.
export const scaffolderWrapperModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    byxScaffolderWrapper,
    byxRegisterExistingAction,
    byxDeploymentPickerField,
    byxReviewField,
    byxExecutionsSubPage,
  ],
});
